/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconEditFilled from 'DesignSystem/Svgs/TysiaIconEditFilled/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function EditAction({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Note/ViewNoteDialog/EditAction"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<button
  data-testid="EditAction.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconEditFilled
  viewPath={`${viewPath}/TysiaIconEditFilled`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill2="#513C06"
/>
</button>
{children}
</React.Fragment>)
}